// 加密
import { JSEncrypt } from 'jsencrypt'
const key = `MIGJAoGBAMHWfk0nWJe2gpgfD6uJZAHN6G974IwL4RY4lXbnqozuOXuXn0RZqoLT94We7M+yDYhKYv5dHfMpyHoRGuv694/iV7meYtMgaQcA6d9lm4Isn+mbJ2fr1Q87jkKGFJJJI8wPab4ZBiULNIX0tBLh2X2KVnfOX0zsa/VRE7C4XSlBAgMBAAE=`
const jsencrypt = new JSEncrypt()
jsencrypt.setPublicKey(key)

export default jsencrypt
